<template>
    <el-card>
        <div>ID: {{ CardFragmentParams.id }}
            <CopyButton :text="CardFragmentParams.id" />
        </div>
        <el-collapse v-model="activeNames">
            <el-collapse-item title="基本信息" name="base">
                <el-form :model="CardFragmentParams" label-width="100px">
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="名称" prop="name">
                                {{ CardFragmentParams.name }}
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="排序值" prop="sort">
                                {{ CardFragmentParams.sort }}
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24">
                            <el-form-item label="图片" prop="image">
                                <div class="col-image">
                                    <img v-if="CardFragmentParams.image" :src="CardFragmentParams.image" alt="image"
                                        loading="lazy" @click="openPreview(CardFragmentParams.image)" />
                                </div>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </el-collapse-item>
            <el-collapse-item title="包含卡片" name="cards">
                <div class="image-grid">
                    <template v-for="card in CardFragmentParams.cards" :key="card.id">
                        <div class="image-grid-inner">
                            <el-image :src="cardStore.cardsObj[card.cardId]?.image" fit="cover" class="image-option" />
                            <span>{{ cardStore.cardsObj[card.cardId]?.name }}</span>
                            <span>{{ cardStore.cardsObj[card.cardId]?.rarity }}: {{
                                cardStore.cardsObj[card.cardId]?.value }}</span>
                            <span>数量: {{ card.rest }} / {{ card.total }}</span>
                            <span>抽中率: {{ card.rate }}%</span>
                        </div>
                    </template>
                </div>
            </el-collapse-item>

            <el-collapse-item title="合成记录" name="synthesis">
                <div class="table-wrapper">
                    <el-table :data="synthesisLogsInfo.rows" v-loading="synthesisLogsInfo.loading" style="width: 100%">
                        <el-table-column label="ID" prop="id" width="200" />
                        <el-table-column label="用户ID" prop="userId" width="200">
                            <template #default="scope">
                                <el-link underline="always" type="primary" @click="viewUser(scope.row.userId)">{{
                                    scope.row.userId
                                }}</el-link>
                            </template>
                        </el-table-column>
                        <el-table-column label="获得卡片" prop="cards" width="150">
                            <template #default="scope">
                                <div class="draw-images">
                                    <div v-for="([id, count], index) in Object.entries(scope.row.cards)" :key="id"
                                        class="draw-image-item">
                                        <el-badge :value="count" type="primary" :offset="[-15, 10]">
                                            <img :src="cardStore.cardsObj[id]?.image" loading="lazy" />
                                        </el-badge>
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="时间" prop="createdAt" width="200">
                            <template #default="scope">
                                {{ $formatTime(scope.row.createdAt) }}
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="pagination-wrapper">
                    <el-pagination v-model:current-page="synthesisLogsInfo.page"
                        v-model:page-size="synthesisLogsInfo.size" :page-sizes="[10, 20, 50]"
                        :total="synthesisLogsInfo.total" layout="total, sizes, prev, pager, next, jumper"
                        @current-change="loadSynthesisLogs" @size-change="loadSynthesisLogs" />
                </div>
            </el-collapse-item>
        </el-collapse>
    </el-card>
    <el-image-viewer v-if="showPreview" :url-list="showList" :initial-index="previewIndex" @close="showPreview = false"
        :hide-on-click-modal="true" />
</template>

<script setup>
import { ref, reactive, watch, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { apiCall } from "@/utils/api";
import { useCardStore } from "@/stores/card/card";

const cardStore = useCardStore();
const route = useRoute();
const router = useRouter();

const loading = ref(false);

const activeNames = ref(['base', 'cards']);

watch(
    () => activeNames,
    (newAns) => {
        const ans = newAns.value || [];
        if (ans.includes("synthesis") && !synthesisLogsInfo.loaded) {
            loadSynthesisLogs();
        }
    },
    { deep: true }
);

const CardFragmentParams = reactive({
    id: "",
    name: "",
    image: "",
    sort: 50,
    cards: [],
});

const showList = ref([]);
const showPreview = ref(false);
const previewIndex = ref(0);

const openPreview = (url) => {
    showList.value = [url];
    previewIndex.value = 0;
    showPreview.value = true;
}

const synthesisLogsInfo = reactive({
    loading: false,
    loaded: false,
    rows: [],
    page: 1,
    size: 10,
    total: 0,
});

async function loadSynthesisLogs() {
    const { id } = route.params;

    synthesisLogsInfo.loading = true;
    const params = {
        packId: id,
        page: synthesisLogsInfo.page,
        size: synthesisLogsInfo.size,
    };
    // TODO
    const response = await apiCall("card.getPackDrawLogs", params);
    if (!response) {
        synthesisLogsInfo.loading = false;
        return false;
    }
    synthesisLogsInfo.rows = response.rows;
    synthesisLogsInfo.total = response.count;

    synthesisLogsInfo.loading = false;
    synthesisLogsInfo.loaded = true;
}

function viewUser(id) {
    router.push(`/user/${id}`);
}

async function loadData(id) {
    loading.value = true;
    const response = await apiCall("card.getFragment", { id });
    if (!response) {
        loading.value = false;
        return false;
    }

    Object.keys(CardFragmentParams).forEach(key => {
        CardFragmentParams[key] = response[key];
    });

    loading.value = false;
}

onMounted(async () => {
    if (!route.params.id) {
        alert("empty id");
        return router.go(-1);
    }

    await cardStore.getAll();
    await loadData(route.params.id);
});
</script>

<style scoped>
.basic-part .el-row {
    margin-bottom: 10px;
}

.col-image {
    position: relative;
    width: 180px;
    height: 180px;
    border-radius: 8px;
    overflow: hidden;
    cursor: pointer;
}

.col-image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s ease;
}

.col-image:hover img {
    transform: scale(1.05);
}

.image-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
    gap: 10px;
}

.image-grid-inner {
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
}

.image-grid-inner:hover {
    transform: scale(1.03);
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.image-grid-inner span {
    width: 160px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    text-align: center;
}

.draw-images {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(60px, 1fr));
    gap: 2px;
    padding: 2px;
}

.draw-image-item {
    position: relative;
    width: 60px;
    aspect-ratio: 3 / 4;
    overflow: hidden;
    border-radius: 8px;
    background: #f6f6f6;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.draw-image-item:hover {
    transform: scale(1.03);
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.draw-image-item img {
    width: 60px;
    aspect-ratio: 3 / 4;
    object-fit: cover;
    cursor: pointer;
    transition: 0.3s ease;
}
</style>
